<template>
  <div class="card">

    <div class="card-header header-elements-inline" style="padding-top: 10px;padding-bottom: 10px; background-color: lightgrey;">
      <h5 class="card-title">Container Stock Report</h5>
      <div class="header-elements">
        <div class="list-icons">
          <a class="list-icons-item" data-action="modal" @click="showFilterWindow"></a>
          <a class="list-icons-item" data-action="reload" @click="loadData"></a>
          <a class="list-icons-item" data-action="remove" @click="closeWindow"></a>
        </div>
      </div>
    </div>


    <table class="table table-bordered table-condensed table-columned table-hover"
           data-search="false"
           data-pagination="true"
           data-show-refresh="false"
           data-show-columns="false"
           data-page-list="[10, 25, 50, 100, ALL]"
           data-show-footer="false"
           data-toggle="context"
           data-target=".context-table">
      <thead>
      <tr>
        <th style="width: 50px;">S.No</th>
        <th>Type</th>
        <th>Container</th>
        <th>Quality</th>
        <th>Color</th>
        <th class="text-right">Weight</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(det,idx) in deliveries">
        <td class="footable-visible">{{idx + 1}}</td>
        <td class="footable-visible">{{det.type | contianerTypeFormatter}}</td>
        <td class="footable-visible">{{det.name}}</td>
        <td class="footable-visible">{{det.quality.name}}</td>
        <td>{{det.color.name}}</td>
        <td class="footable-visible text-right">{{det.wgt| weightFormat}}</td>
      </tr>

      </tbody>
    </table>

    <vmodal name="filter-window" transition="nice-modal-fade" :delay="100" :resizable="true" width="42%" height="360">
      <form>
        <div class="card">
          <div class="card-header header-elements-inline bg-primary" style="padding: 10px;">
            <h3 class="card-title">Filter</h3>
            <div class="header-elements">
              <div class="list-icons">
                <!--<a class="list-icons-item" data-action="remove" @click="closeRequest"></a>-->
              </div>
            </div>
          </div>

          <div class="card-body">

            <p/>


            <div class="form-group row">
              <label class="col-md-3 col-form-label font-weight-semibold">Type:</label>
              <div class="col-md-9">
                <select class="form-control" v-model="cont_type">
                  <option value="0">All</option>
                  <option value="1">Cone</option>
                  <option value="2">Babin</option>
                  <option value="3">Beam</option>
                </select>
              </div>
            </div>

            <div class="form-group row">
              <label class="col-md-3 col-form-label">Quality:</label>
              <div class="col-md-9">
                <select id="cmbQuality" class="form-control" v-model="qua">
                  <option value="0" selected>All</option>
                  <option v-for="ledger in qualities" v-bind:value="ledger.code">
                    {{ ledger.name }}
                  </option>
                </select>
              </div>
            </div>


            <div class="form-group row">
              <label class="col-md-3 col-form-label">Color:</label>
              <div class="col-md-9">
                <select class="form-control" v-model="col">
                  <option value="0" selected>All</option>
                  <option v-for="ledger in colors" v-bind:value="ledger.code">
                    {{ ledger.name }}
                  </option>
                </select>
              </div>
            </div>

            <div class="form-group row">
              <label class="col-md-3 col-form-label font-weight-semibold">Weight:</label>
              <div class="col-md-9">
                <select class="form-control" >
                  <option value="0">All</option>
                  <option value="1">Empty</option>
                  <option value="2">Full</option>
                </select>
              </div>
            </div>


            <div class="text-right">
              <button type="button"
                      class="btn btn-outline alpha-success text-success-800 border-success-600 legitRipple"
                      @click="loadData">Show Data<i class="icon-database-refresh ml-2"></i></button>
            </div>

          </div>
        </div>
      </form>
    </vmodal>


    <!-- Context Menu -->
    <div id="context-menu" class="context-table">
      <div class="dropdown-menu">
        <a href="#" class="dropdown-item" @click="loadData"><i class="icon-reset"
                                                               style="color: darkgreen"></i>Refresh</a>
        <div class="dropdown-divider"></div>
        <a href="#" class="dropdown-item" style="color: darkgreen;"> <i class="icon-file-excel"></i>Export</a>
        <div class="dropdown-divider"></div>
        <a href="#" class="dropdown-item" @click="printPreview"> <i class="icon-file-eye2"></i>Preview</a>
      </div>
    </div>
    <!-- End of Context Menu -->

    <vmodal name="viewer-window" transition="nice-modal-fade" :resizable="true" width="80%" height="500" @opened="afterOpen" >
      <div id="viewer-host">
      </div>
    </vmodal>


    <!-- Clickable menu -->
    <ul class="fab-menu fab-menu-fixed fab-menu-bottom-right is_stuck" data-fab-toggle="hover" z-index="0">
      <li>
        <a class="fab-menu-btn btn bg-primary-600 btn-float rounded-round btn-icon" @click="showFilterWindow">
          <i class="fab-icon-open icon-filter3"></i>
          <i class="fab-icon-close icon-filter4"></i>
        </a>
      </li>
    </ul>
    <!-- /clickable menu -->



  </div>
</template>

<script>
  import moment from 'moment-timezone';
  import { userService } from '@/store/auth-header.js';
  import { store } from '@/store/store.js';

  export default {
    name: 'ContainerReport',
    store,
    components: {

    },
    data () {
      return {
        mytable: {},
        viewer: {},
        deliveries: [],
        qualities: [],
        colors: [],
        cont_type: 0,
        col: 0,
        qua: 0,
      }
    },
    mounted () {
      const self = this;

      this.$data.mytable = $('.table');

      this.loadQualities();
      this.loadColors();
      this.showFilterWindow();

      //this.$data.viewer = new ActiveReports.Viewer("#viewer-host");

      //  https://www.grapecity.com/activereportsjs/demos/resource/reports/Frontstore.rdlx-json
    },
    filters: {
      weightFormat (value) {
        if (value !== 0) {
          return value.toFixed(3)
        } else {
          return ''
        }
      },
      dateFormatter (val) {
        try {
          return val.slice(0, 10).split('-').reverse().join('-')
        } catch (ex) {

        }
        return ''
      },
      shiftFormatter (val) {
        try {
          if (val == 2) {
            return 'Day'
          } else if (val == 3) {
            return 'Night'
          }
          return val
        } catch (ex) {

        }
        return ''
      },
      contianerTypeFormatter (val) {
        switch (val) {
          case 1:
            return 'Cone'
          case 2:
            return 'Babin'
          case 3:
            return 'Beam'
        }
        return val
      },
    },
    methods: {
      showFilterWindow () {
        this.$modal.show('filter-window')
      },
      closeWindow () {
        this.$router.push('/')
      },
      afterOpen(){
        this.$data.viewer = new ActiveReports.Viewer("#viewer-host");
        let report = {"Name":"Report","Type":"report","Width":"7.5in","CustomProperties":[{"Name":"DisplayType","Value":"Page"},{"Name":"SizeType","Value":"Default"}],"Page":{"BottomMargin":"0.5in","LeftMargin":"0.5in","PageHeight":"11in","PageWidth":"8.5in","PageOrientation":"Portrait","RightMargin":"0.5in","TopMargin":"0.5in","ColumnSpacing":"0in","Columns":1},"Layers":[{"Type":"layer","Name":"default"}],"Body":{"Type":"section","Height":"0.5209in","Name":"Body","ReportItems":[{"ZIndex":1,"DataSetName":"DataSet","Type":"table","Top":"0.0209in","Left":"0.0104in","Width":"7.4792in","Height":"0.5in","TableColumns":[{"Type":"tablecolumn","Width":"1.4958in"},{"Type":"tablecolumn","Width":"1.4958in"},{"Type":"tablecolumn","Width":"1.4958in"},{"Type":"tablecolumn","Width":"1.4958in"},{"Type":"tablecolumn","Width":"1.496in"}],"Header":{"Type":"tableheader","TableRows":[{"Type":"tablerow","Height":"0.25in","TableCells":[{"Item":{"KeepTogether":true,"Type":"textbox","Width":"1.4958in","Height":"0.25in","CanGrow":true,"Value":"Type","Style":{"FontSize":"11pt","FontWeight":"Bold","PaddingLeft":"2pt","PaddingRight":"2pt","PaddingTop":"2pt","PaddingBottom":"2pt"},"Name":"TextBox86"},"ColSpan":1,"RowSpan":1,"AutoMergeMode":"Never"},{"Item":{"KeepTogether":true,"Type":"textbox","Width":"1.4958in","Height":"0.25in","CanGrow":true,"Value":"Container","Style":{"FontSize":"11pt","FontWeight":"Bold","PaddingLeft":"2pt","PaddingRight":"2pt","PaddingTop":"2pt","PaddingBottom":"2pt"},"Name":"TextBox84"},"ColSpan":1,"RowSpan":1,"AutoMergeMode":"Never"},{"Item":{"KeepTogether":true,"Type":"textbox","Width":"1.4958in","Height":"0.25in","CanGrow":true,"Value":"Quality","Style":{"FontSize":"11pt","FontWeight":"Bold","PaddingLeft":"2pt","PaddingRight":"2pt","PaddingTop":"2pt","PaddingBottom":"2pt"},"Name":"TextBox85"},"ColSpan":1,"RowSpan":1,"AutoMergeMode":"Never"},{"Item":{"KeepTogether":true,"Type":"textbox","Width":"1.4958in","Height":"0.25in","CanGrow":true,"Value":"Color","Style":{"FontSize":"11pt","FontWeight":"Bold","PaddingLeft":"2pt","PaddingRight":"2pt","PaddingTop":"2pt","PaddingBottom":"2pt"},"Name":"TextBox83"},"ColSpan":1,"RowSpan":1,"AutoMergeMode":"Never"},{"Item":{"KeepTogether":true,"Type":"textbox","Width":"1.496in","Height":"0.25in","CanGrow":true,"Value":"Weight","Style":{"TextAlign":"Right","FontSize":"11pt","FontWeight":"Bold","PaddingLeft":"2pt","PaddingRight":"2pt","PaddingTop":"2pt","PaddingBottom":"2pt"},"Name":"TextBox87"},"ColSpan":1,"RowSpan":1,"AutoMergeMode":"Never"}]}],"RepeatOnNewPage":true},"Details":{"Type":"tabledetails","TableRows":[{"Type":"tablerow","Height":"0.25in","TableCells":[{"Item":{"KeepTogether":true,"DataElementName":"type","Type":"textbox","Width":"1.4958in","Height":"0.25in","CanGrow":true,"Value":"=  IIF( ToInt16(Fields!type.Value) is 1, \"Cone\",  IIF( ToInt16(Fields!type.Value) is 2, \"Babin\",  \"Beam\" ) )","Style":{"TextAlign":"Left","PaddingLeft":"2pt","PaddingRight":"2pt","PaddingTop":"2pt","PaddingBottom":"2pt"},"Name":"TextBox91"},"ColSpan":1,"RowSpan":1,"AutoMergeMode":"Never"},{"Item":{"KeepTogether":true,"DataElementName":"name","Type":"textbox","Width":"1.4958in","Height":"0.25in","CanGrow":true,"Value":"=Fields!name.Value","Style":{"PaddingLeft":"2pt","PaddingRight":"2pt","PaddingTop":"2pt","PaddingBottom":"2pt"},"Name":"TextBox89"},"ColSpan":1,"RowSpan":1,"AutoMergeMode":"Never"},{"Item":{"KeepTogether":true,"DataElementName":"quality.p_name","Type":"textbox","Width":"1.4958in","Height":"0.25in","CanGrow":true,"Value":"=Fields.Item(\"quality.p_name\").Value","Style":{"PaddingLeft":"2pt","PaddingRight":"2pt","PaddingTop":"2pt","PaddingBottom":"2pt"},"Name":"TextBox90"},"ColSpan":1,"RowSpan":1,"AutoMergeMode":"Never"},{"Item":{"KeepTogether":true,"DataElementName":"color.p_name","Type":"textbox","Width":"1.4958in","Height":"0.25in","CanGrow":true,"Value":"=Fields.Item(\"color.p_name\").Value","Style":{"PaddingLeft":"2pt","PaddingRight":"2pt","PaddingTop":"2pt","PaddingBottom":"2pt"},"Name":"TextBox88"},"ColSpan":1,"RowSpan":1,"AutoMergeMode":"Never"},{"Item":{"KeepTogether":true,"DataElementName":"wgt","Type":"textbox","Width":"1.496in","Height":"0.25in","CanGrow":true,"Value":"=Fields!wgt.Value","Style":{"TextAlign":"Right","Format":"n3","PaddingLeft":"2pt","PaddingRight":"2pt","PaddingTop":"2pt","PaddingBottom":"2pt"},"Name":"TextBox92"},"ColSpan":1,"RowSpan":1,"AutoMergeMode":"Never"}]}],"Group":{"Name":""}},"Name":"Table2"},{"ZIndex":2,"Type":"line","StartPoint":{"X":"0in","Y":"0in"},"EndPoint":{"X":"7.4792in","Y":"0in"},"Name":"Line2"},{"ZIndex":3,"Type":"line","StartPoint":{"X":"0in","Y":"0.25in"},"EndPoint":{"X":"7.4792in","Y":"0.25in"},"Name":"Line3"}]},"DataSources":[{"Name":"DataSource","Transaction":false,"DataSourceReference":"","ConnectionProperties":{"DataProvider":"JSONEMBED","ConnectString":"jsondata=","IntegratedSecurity":false,"Prompt":"","Collation":"","AccentSensivity":"Auto","WidthSensivity":"Auto"}}],"DataSets":[{"Name":"DataSet","Fields":[{"Name":"_id","DataField":"_id"},{"Name":"code","DataField":"code"},{"Name":"color._id","DataField":"color._id"},{"Name":"color.chart","DataField":"color.chart"},{"Name":"color.code","DataField":"color.code"},{"Name":"color.key","DataField":"color.key"},{"Name":"color.name","DataField":"color.name"},{"Name":"color.p_name","DataField":"color.p_name"},{"Name":"color.status","DataField":"color.status"},{"Name":"color.wgt","DataField":"color.wgt"},{"Name":"grs_wgt","DataField":"grs_wgt"},{"Name":"item._id","DataField":"item._id"},{"Name":"item.bra","DataField":"item.bra"},{"Name":"item.cat","DataField":"item.cat"},{"Name":"item.code","DataField":"item.code"},{"Name":"item.col","DataField":"item.col"},{"Name":"item.des","DataField":"item.des"},{"Name":"item.gro","DataField":"item.gro"},{"Name":"item.key","DataField":"item.key"},{"Name":"item.ldgp","DataField":"item.ldgp"},{"Name":"item.name","DataField":"item.name"},{"Name":"item.nature","DataField":"item.nature"},{"Name":"item.p_name","DataField":"item.p_name"},{"Name":"item.pro","DataField":"item.pro"},{"Name":"item.qua","DataField":"item.qua"},{"Name":"item.rate","DataField":"item.rate"},{"Name":"item.siz","DataField":"item.siz"},{"Name":"item.sty","DataField":"item.sty"},{"Name":"item.unit","DataField":"item.unit"},{"Name":"itm","DataField":"itm"},{"Name":"key","DataField":"key"},{"Name":"name","DataField":"name"},{"Name":"quality._id","DataField":"quality._id"},{"Name":"quality.code","DataField":"quality.code"},{"Name":"quality.colors_wgt","DataField":"quality.colors_wgt"},{"Name":"quality.key","DataField":"quality.key"},{"Name":"quality.name","DataField":"quality.name"},{"Name":"quality.p_name","DataField":"quality.p_name"},{"Name":"status","DataField":"status"},{"Name":"type","DataField":"type"},{"Name":"wgt","DataField":"wgt"}],"Query":{"DataSourceName":"DataSource","CommandType":"Text","CommandText":"uri=http://localhost:8080/data.json;jpath=$.[*]","Timeout":0},"CaseSensitivity":"Auto","Collation":"","KanatypeSensitivity":"Auto","AccentSensitivity":"Auto","WidthSensitivity":"Auto"}],"PageHeader":{"Type":"pagesection","Height":"0.5521in","ReportItems":[{"KeepTogether":true,"Type":"textbox","Top":"0.25in","Left":"0.0209in","Width":"7.4687in","Height":"0.25in","CanGrow":true,"Value":"Stock Report","Style":{"TextAlign":"Center","FontSize":"12pt","FontWeight":"Bold","PaddingLeft":"2pt","PaddingRight":"2pt","PaddingTop":"2pt","PaddingBottom":"2pt"},"Name":"TextBox2"}],"Name":"PageHeader"},"PageFooter":{"Type":"pagesection","Height":"0.25in","ReportItems":[{"KeepTogether":true,"Type":"textbox","Left":"5.6875in","Width":"1.8125in","Height":"0.25in","CanGrow":true,"Value":"=\"Page \" & Globals!PageNumber & \" of \" & Globals!TotalPages","Style":{"TextAlign":"Right","PaddingLeft":"2pt","PaddingRight":"2pt","PaddingTop":"2pt","PaddingBottom":"2pt"},"Name":"TextBox1"},{"ZIndex":1,"Type":"line","StartPoint":{"X":"0in","Y":"0in"},"EndPoint":{"X":"7.4896in","Y":"0in"},"Name":"Line1"}],"Name":"PageFooter"}};
        report.DataSources[0].ConnectionProperties.ConnectString = "jsondata=" + JSON.stringify(this.$data.deliveries);

        this.$data.viewer.open(report);
      },
      loadData () {
        const self = this

        const requestOptions = {
          method: 'GET',
          mode: 'cors',
          headers: userService.authHeader()
        }

        $(self.$data.mytable).block({
          message: '<i class="icon-spinner2 spinner"></i>',
          overlayCSS: {
            backgroundColor: '#fff',
            opacity: 0.8,
            cursor: 'wait',
            'box-shadow': '0 0 0 1px #ddd'
          },
          css: {
            border: 0,
            padding: 0,
            backgroundColor: 'none'
          }
        });

        self.$modal.hide('filter-window')
        self.$data.mytable.bootstrapTable('load', [])
        self.$data.mytable.bootstrapTable('showLoading')

        self.$data.deliveries = [];


        fetch(`${process.env.VUE_APP_ROOT_API}report/container/stock?ctype=${self.$data.cont_type}&col=${self.$data.col}&qua=${self.$data.qua}`, requestOptions).then(userService.handleResponse).then(function (resp) {

          if (resp.ok) {
            if(Array.isArray(resp.data)){
              self.$data.deliveries = resp.data
            }
          } else {
            swal({ title: 'Oops', text: resp.message, type: 'error' })
          }
          self.$data.mytable.bootstrapTable('hideLoading')
        }).catch(function (err) {
          swal({ title: 'Oops', text: err.toString(), type: 'error' })
        }).finally(function () {
          $(self.$data.mytable).unblock()
        })

      },
      loadQualities () {
        const self = this

        const requestOptions = {
          method: 'GET',
          mode: 'cors',
          headers: userService.authHeader()
        }

        self.$data.qualities = []
        fetch(`${process.env.VUE_APP_ROOT_API}api/qualities`, requestOptions).then(userService.handleResponse).then(function (resp) {

          if (resp.ok) {
            self.$data.qualities = resp.data
          } else {
            swal({ title: 'Oops', text: resp.message, type: 'error' })
          }
        }).catch(function (err) {
          swal({ title: 'Oops', text: err.toString(), type: 'error' })
        })
      },
      loadColors () {
        const self = this

        const requestOptions = {
          method: 'GET',
          mode: 'cors',
          headers: userService.authHeader()
        }

        self.$data.colors = []
        fetch(`${process.env.VUE_APP_ROOT_API}api/colorcharts`, requestOptions).then(userService.handleResponse).then(function (resp) {

          if (resp.ok) {
            self.$data.colors = resp.data
          } else {
            swal({ title: 'Oops', text: resp.message, type: 'error' })
          }
        }).catch(function (err) {
          swal({ title: 'Oops', text: err.toString(), type: 'error' })
        })
      },
      printPreview() {

        const self = this;
        self.$modal.show('viewer-window');

        try {
          let report = {"Name":"Report","Type":"report","Width":"7.5in","CustomProperties":[{"Name":"DisplayType","Value":"Page"},{"Name":"SizeType","Value":"Default"}],"Page":{"BottomMargin":"0.5in","LeftMargin":"0.5in","PageHeight":"11in","PageWidth":"8.5in","PageOrientation":"Portrait","RightMargin":"0.5in","TopMargin":"0.5in","ColumnSpacing":"0in","Columns":1},"Layers":[{"Type":"layer","Name":"default"}],"Body":{"Type":"section","Height":"0.5209in","Name":"Body","ReportItems":[{"ZIndex":1,"DataSetName":"DataSet","Type":"table","Top":"0.0209in","Left":"0.0104in","Width":"7.4792in","Height":"0.5in","TableColumns":[{"Type":"tablecolumn","Width":"1.4958in"},{"Type":"tablecolumn","Width":"1.4958in"},{"Type":"tablecolumn","Width":"1.4958in"},{"Type":"tablecolumn","Width":"1.4958in"},{"Type":"tablecolumn","Width":"1.496in"}],"Header":{"Type":"tableheader","TableRows":[{"Type":"tablerow","Height":"0.25in","TableCells":[{"Item":{"KeepTogether":true,"Type":"textbox","Width":"1.4958in","Height":"0.25in","CanGrow":true,"Value":"Type","Style":{"FontSize":"11pt","FontWeight":"Bold","PaddingLeft":"2pt","PaddingRight":"2pt","PaddingTop":"2pt","PaddingBottom":"2pt"},"Name":"TextBox86"},"ColSpan":1,"RowSpan":1,"AutoMergeMode":"Never"},{"Item":{"KeepTogether":true,"Type":"textbox","Width":"1.4958in","Height":"0.25in","CanGrow":true,"Value":"Container","Style":{"FontSize":"11pt","FontWeight":"Bold","PaddingLeft":"2pt","PaddingRight":"2pt","PaddingTop":"2pt","PaddingBottom":"2pt"},"Name":"TextBox84"},"ColSpan":1,"RowSpan":1,"AutoMergeMode":"Never"},{"Item":{"KeepTogether":true,"Type":"textbox","Width":"1.4958in","Height":"0.25in","CanGrow":true,"Value":"Quality","Style":{"FontSize":"11pt","FontWeight":"Bold","PaddingLeft":"2pt","PaddingRight":"2pt","PaddingTop":"2pt","PaddingBottom":"2pt"},"Name":"TextBox85"},"ColSpan":1,"RowSpan":1,"AutoMergeMode":"Never"},{"Item":{"KeepTogether":true,"Type":"textbox","Width":"1.4958in","Height":"0.25in","CanGrow":true,"Value":"Color","Style":{"FontSize":"11pt","FontWeight":"Bold","PaddingLeft":"2pt","PaddingRight":"2pt","PaddingTop":"2pt","PaddingBottom":"2pt"},"Name":"TextBox83"},"ColSpan":1,"RowSpan":1,"AutoMergeMode":"Never"},{"Item":{"KeepTogether":true,"Type":"textbox","Width":"1.496in","Height":"0.25in","CanGrow":true,"Value":"Weight","Style":{"TextAlign":"Right","FontSize":"11pt","FontWeight":"Bold","PaddingLeft":"2pt","PaddingRight":"2pt","PaddingTop":"2pt","PaddingBottom":"2pt"},"Name":"TextBox87"},"ColSpan":1,"RowSpan":1,"AutoMergeMode":"Never"}]}],"RepeatOnNewPage":true},"Details":{"Type":"tabledetails","TableRows":[{"Type":"tablerow","Height":"0.25in","TableCells":[{"Item":{"KeepTogether":true,"DataElementName":"type","Type":"textbox","Width":"1.4958in","Height":"0.25in","CanGrow":true,"Value":"=  IIF( ToInt16(Fields!type.Value) is 1, \"Cone\",  IIF( ToInt16(Fields!type.Value) is 2, \"Babin\",  \"Beam\" ) )","Style":{"TextAlign":"Left","PaddingLeft":"2pt","PaddingRight":"2pt","PaddingTop":"2pt","PaddingBottom":"2pt"},"Name":"TextBox91"},"ColSpan":1,"RowSpan":1,"AutoMergeMode":"Never"},{"Item":{"KeepTogether":true,"DataElementName":"name","Type":"textbox","Width":"1.4958in","Height":"0.25in","CanGrow":true,"Value":"=Fields!name.Value","Style":{"PaddingLeft":"2pt","PaddingRight":"2pt","PaddingTop":"2pt","PaddingBottom":"2pt"},"Name":"TextBox89"},"ColSpan":1,"RowSpan":1,"AutoMergeMode":"Never"},{"Item":{"KeepTogether":true,"DataElementName":"quality.p_name","Type":"textbox","Width":"1.4958in","Height":"0.25in","CanGrow":true,"Value":"=Fields.Item(\"quality.p_name\").Value","Style":{"PaddingLeft":"2pt","PaddingRight":"2pt","PaddingTop":"2pt","PaddingBottom":"2pt"},"Name":"TextBox90"},"ColSpan":1,"RowSpan":1,"AutoMergeMode":"Never"},{"Item":{"KeepTogether":true,"DataElementName":"color.p_name","Type":"textbox","Width":"1.4958in","Height":"0.25in","CanGrow":true,"Value":"=Fields.Item(\"color.p_name\").Value","Style":{"PaddingLeft":"2pt","PaddingRight":"2pt","PaddingTop":"2pt","PaddingBottom":"2pt"},"Name":"TextBox88"},"ColSpan":1,"RowSpan":1,"AutoMergeMode":"Never"},{"Item":{"KeepTogether":true,"DataElementName":"wgt","Type":"textbox","Width":"1.496in","Height":"0.25in","CanGrow":true,"Value":"=Fields!wgt.Value","Style":{"TextAlign":"Right","Format":"n3","PaddingLeft":"2pt","PaddingRight":"2pt","PaddingTop":"2pt","PaddingBottom":"2pt"},"Name":"TextBox92"},"ColSpan":1,"RowSpan":1,"AutoMergeMode":"Never"}]}],"Group":{"Name":""}},"Name":"Table2"},{"ZIndex":2,"Type":"line","StartPoint":{"X":"0in","Y":"0in"},"EndPoint":{"X":"7.4792in","Y":"0in"},"Name":"Line2"},{"ZIndex":3,"Type":"line","StartPoint":{"X":"0in","Y":"0.25in"},"EndPoint":{"X":"7.4792in","Y":"0.25in"},"Name":"Line3"}]},"DataSources":[{"Name":"DataSource","Transaction":false,"DataSourceReference":"","ConnectionProperties":{"DataProvider":"JSONEMBED","ConnectString":"jsondata=","IntegratedSecurity":false,"Prompt":"","Collation":"","AccentSensivity":"Auto","WidthSensivity":"Auto"}}],"DataSets":[{"Name":"DataSet","Fields":[{"Name":"_id","DataField":"_id"},{"Name":"code","DataField":"code"},{"Name":"color._id","DataField":"color._id"},{"Name":"color.chart","DataField":"color.chart"},{"Name":"color.code","DataField":"color.code"},{"Name":"color.key","DataField":"color.key"},{"Name":"color.name","DataField":"color.name"},{"Name":"color.p_name","DataField":"color.p_name"},{"Name":"color.status","DataField":"color.status"},{"Name":"color.wgt","DataField":"color.wgt"},{"Name":"grs_wgt","DataField":"grs_wgt"},{"Name":"item._id","DataField":"item._id"},{"Name":"item.bra","DataField":"item.bra"},{"Name":"item.cat","DataField":"item.cat"},{"Name":"item.code","DataField":"item.code"},{"Name":"item.col","DataField":"item.col"},{"Name":"item.des","DataField":"item.des"},{"Name":"item.gro","DataField":"item.gro"},{"Name":"item.key","DataField":"item.key"},{"Name":"item.ldgp","DataField":"item.ldgp"},{"Name":"item.name","DataField":"item.name"},{"Name":"item.nature","DataField":"item.nature"},{"Name":"item.p_name","DataField":"item.p_name"},{"Name":"item.pro","DataField":"item.pro"},{"Name":"item.qua","DataField":"item.qua"},{"Name":"item.rate","DataField":"item.rate"},{"Name":"item.siz","DataField":"item.siz"},{"Name":"item.sty","DataField":"item.sty"},{"Name":"item.unit","DataField":"item.unit"},{"Name":"itm","DataField":"itm"},{"Name":"key","DataField":"key"},{"Name":"name","DataField":"name"},{"Name":"quality._id","DataField":"quality._id"},{"Name":"quality.code","DataField":"quality.code"},{"Name":"quality.colors_wgt","DataField":"quality.colors_wgt"},{"Name":"quality.key","DataField":"quality.key"},{"Name":"quality.name","DataField":"quality.name"},{"Name":"quality.p_name","DataField":"quality.p_name"},{"Name":"status","DataField":"status"},{"Name":"type","DataField":"type"},{"Name":"wgt","DataField":"wgt"}],"Query":{"DataSourceName":"DataSource","CommandType":"Text","CommandText":"uri=http://localhost:8080/data.json;jpath=$.[*]","Timeout":0},"CaseSensitivity":"Auto","Collation":"","KanatypeSensitivity":"Auto","AccentSensitivity":"Auto","WidthSensitivity":"Auto"}],"PageHeader":{"Type":"pagesection","Height":"0.5521in","ReportItems":[{"KeepTogether":true,"Type":"textbox","Top":"0.25in","Left":"0.0209in","Width":"7.4687in","Height":"0.25in","CanGrow":true,"Value":"Stock Report","Style":{"TextAlign":"Center","FontSize":"12pt","FontWeight":"Bold","PaddingLeft":"2pt","PaddingRight":"2pt","PaddingTop":"2pt","PaddingBottom":"2pt"},"Name":"TextBox2"}],"Name":"PageHeader"},"PageFooter":{"Type":"pagesection","Height":"0.25in","ReportItems":[{"KeepTogether":true,"Type":"textbox","Left":"5.6875in","Width":"1.8125in","Height":"0.25in","CanGrow":true,"Value":"=\"Page \" & Globals!PageNumber & \" of \" & Globals!TotalPages","Style":{"TextAlign":"Right","PaddingLeft":"2pt","PaddingRight":"2pt","PaddingTop":"2pt","PaddingBottom":"2pt"},"Name":"TextBox1"},{"ZIndex":1,"Type":"line","StartPoint":{"X":"0in","Y":"0in"},"EndPoint":{"X":"7.4896in","Y":"0in"},"Name":"Line1"}],"Name":"PageFooter"}};
          report.DataSources[0].ConnectionProperties.ConnectString = "jsondata=" + JSON.stringify(self.$data.deliveries);

          // self.$data.viewer.open(report);

        }catch (e) {
          alert(e + '\nprintPreview');
        }
      },
    },
  }
</script>

<style scoped>
  #viewer-host {
    margin: 0 auto;
    width: 100%;
    height: 100%;
  }
</style>
